import React from "react";
import { Heart, Star, MapPin, Navigation } from "lucide-react";
import { rupiah, fmtKm } from "../lib/format";

export default function DestinationCard({ dest, saved, onSave, onOpen, index = 0, distanceKm = null }) {
  return (
    <article
      className="group relative overflow-hidden rounded-2xl border border-[#efeae4] bg-white kk-shadow-sm transition-all duration-300 hover:-translate-y-1 hover:kk-shadow kk-reveal"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
      data-testid={`destination-card-${dest.id}`}
    >
      <button
        onClick={() => onOpen(dest)}
        className="block w-full"
        data-testid={`destination-open-${dest.id}`}
        aria-label={`Lihat ${dest.name}`}
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-[#ecdfd2]">
          <img
            src={dest.img}
            alt={dest.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <div className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-semibold text-[#6b5f57] backdrop-blur">
            {dest.category}
          </div>
          <div className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-black/45 px-2 py-1 text-[11px] font-bold text-white backdrop-blur">
            <Star className="h-3 w-3 fill-[#ffcb5b] text-[#ffcb5b]" />
            {dest.rating}
          </div>
        </div>
      </button>

      <button
        onClick={(e) => { e.stopPropagation(); onSave(dest.id); }}
        aria-label={saved ? "Hapus dari simpanan" : "Simpan destinasi"}
        data-testid={`save-button-${dest.id}`}
        className={`absolute right-3 top-[calc(75%-1.4rem)] grid h-9 w-9 place-items-center rounded-full bg-white/95 shadow-md transition-transform active:scale-90 ${
          saved ? "text-[#ff5a5f]" : "text-[#9a8b8f]"
        }`}
      >
        <Heart className={`h-[18px] w-[18px] ${saved ? "fill-[#ff5a5f]" : ""}`} />
      </button>

      <div className="p-4">
        <div className="flex items-center gap-1 text-[12px] text-[#8a8278]">
          <MapPin className="h-3.5 w-3.5 text-[#c9878f]" />
          {dest.area}, {dest.city}
          {distanceKm != null && (
            <span className="ml-auto flex items-center gap-1 rounded-full bg-[#eef3ff] px-2 py-0.5 text-[11px] font-bold text-[#4f74c8]">
              <Navigation className="h-3 w-3" /> {fmtKm(distanceKm)}
            </span>
          )}
        </div>
        <h3 className="mt-1 text-[17px] font-bold leading-tight text-[#1e1b18]">{dest.name}</h3>
        <p className="mt-1.5 line-clamp-2 text-[13px] leading-relaxed text-[#8a8278]">{dest.desc}</p>
        <div className="mt-3 flex items-center justify-between border-t border-[#f2ede8] pt-3">
          <div className="text-[15px] font-extrabold text-[#1e1b18]">
            {rupiah(dest.price)}
            <span className="ml-1 text-[11px] font-medium text-[#a89f98]">/ berdua</span>
          </div>
          <button
            onClick={() => onOpen(dest)}
            className="rounded-full bg-[#ffebeb] px-3.5 py-1.5 text-[12px] font-bold text-[#ff5a5f] transition-colors hover:bg-[#ffd9d9]"
            data-testid={`detail-cta-${dest.id}`}
          >
            Lihat
          </button>
        </div>
      </div>
    </article>
  );
}
